// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 14px;
}

.app-name {
  margin: 0;
  font-family: "Montserrat", sans-serif;
  position: absolute;
  color: #09383e;
  top: 15px;
  left: 15px;
}

.container__item {
  margin: 0 auto;
}

.landing-page-container {
  width: 100%;
  min-height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  overflow: hidden;
  font-family: "Montserrat", sans-serif;
  color: #09383e;
}

.content__wrapper {
  max-width: 1200px;
  width: 90%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

.greeting {
  position: absolute;
  top: 16.6rem;
  left: 6rem;
  right: 0;
  margin: 0 auto;
  text-transform: uppercase;
  letter-spacing: 4rem;
  font-size: 2.2rem;
  font-weight: 400;
  opacity: 0.5;
}

.greeting::after {
  content: "";
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  display: inline-block;
  background-color: #0c383e;
  position: relative;
  top: -0.65rem;
  left: -5.05rem;
}

.ellipses-container {
  width: 50rem;
  height: 50rem;
  border-radius: 50%;
  margin: 0 auto;
  position: relative;
  top: 4em;
  left: 10em;
}

.ellipses {
  border-radius: 50%;
  position: absolute;
  top: 0;
  border-style: solid;
}

.ellipses__outer--thin {
  width: 70%;
  height: 70%;
  border-width: 1px;
  border-color: rgba(9, 56, 62, 0.1);
  animation: ellipsesOrbit 15s ease-in-out infinite;
}

.ellipses__outer--thin::after {
  content: "";
  background-image: url("https://s29.postimg.org/5h0r4ftkn/ellipses_dial.png");
  background-repeat: no-repeat;
  background-position: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  opacity: 0.15;
}

.ellipses__outer--thick {
  width: 69.5%;
  height: 69.5%;
  border-color: #09383e transparent;
  border-width: 2px;
  transform: rotate(-45deg);
  animation: ellipsesRotate 15s ease-in-out infinite;
}

.ellipses__orbit {
  width: 2.5rem;
  height: 2.5rem;
  border-width: 2px;
  border-color: #09383e;
  top: 1.3rem;
  right: 6.75rem;
}

.ellipses__orbit::before {
  content: "";
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  display: inline-block;
  background-color: #09383e;
  margin: 0 auto;
  left: 0;
  right: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

@keyframes ellipsesRotate {
  0% {
    transform: rotate(-45deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes ellipsesOrbit {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.order_detail_title {
  color: "#00700 !important";
  font-size: "large !important";
  background: "black !important";
}

.borderBottomGray {
  border-bottom: "1px solid gray";
}

.hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px;
  background: linear-gradient(to right, #ffffff, #f0f0f0);
}

.hero-content h1 {
  color: #e00000;
  font-size: 3rem;
}

.hero-content p {
  color: #000;
  font-size: 1.2rem;
}

.hero-image img {
  width: 100%;
  max-width: 600px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
.top-logistics,
.global-countries,
.connect-countries {
  text-align: center;
  padding: 50px;
}

button {
  background-color: #e00000;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #ff4d4d;
}`, "",{"version":3,"sources":["webpack://./src/scss/index.css"],"names":[],"mappings":"AAAA;;;EAGE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,qCAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kCAAA;EACA,iDAAA;AACF;;AAEA;EACE,WAAA;EACA,4EAAA;EACA,4BAAA;EACA,2BAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,iCAAA;EACA,iBAAA;EACA,yBAAA;EACA,kDAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;EAEA;IACE,0BAAA;EAAF;AACF;AAGA;EACE;IACE,oBAAA;EADF;EAIA;IACE,yBAAA;EAFF;AACF;AAIA;EACE,0BAAA;EACA,6BAAA;EACA,8BAAA;AAFF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,uDAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,iBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,wCAAA;AADF;;AAIA;EACE;IACE,wBAAA;EADF;EAGA;IACE,4BAAA;EADF;AACF;AAIA;;;EAGE,kBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAFF;;AAKA;EACE,yBAAA;AAFF","sourcesContent":["html,\nbody,\n#root {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  font-size: 14px;\n}\n\n.app-name {\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n  position: absolute;\n  color: #09383e;\n  top: 15px;\n  left: 15px;\n}\n\n.container__item {\n  margin: 0 auto;\n}\n\n.landing-page-container {\n  width: 100%;\n  min-height: 100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: bottom;\n  overflow: hidden;\n  font-family: 'Montserrat', sans-serif;\n  color: #09383e;\n}\n\n.content__wrapper {\n  max-width: 1200px;\n  width: 90%;\n  height: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n\n.greeting {\n  position: absolute;\n  top: 16.6rem;\n  left: 6rem;\n  right: 0;\n  margin: 0 auto;\n  text-transform: uppercase;\n  letter-spacing: 4rem;\n  font-size: 2.2rem;\n  font-weight: 400;\n  opacity: 0.5;\n}\n\n.greeting::after {\n  content: '';\n  width: 0.3rem;\n  height: 0.3rem;\n  border-radius: 50%;\n  display: inline-block;\n  background-color: #0c383e;\n  position: relative;\n  top: -0.65rem;\n  left: -5.05rem;\n}\n\n.ellipses-container {\n  width: 50rem;\n  height: 50rem;\n  border-radius: 50%;\n  margin: 0 auto;\n  position: relative;\n  top: 4em;\n  left: 10em;\n}\n\n.ellipses {\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  border-style: solid;\n}\n\n.ellipses__outer--thin {\n  width: 70%;\n  height: 70%;\n  border-width: 1px;\n  border-color: rgba(9, 56, 62, 0.1);\n  animation: ellipsesOrbit 15s ease-in-out infinite;\n}\n\n.ellipses__outer--thin::after {\n  content: '';\n  background-image: url('https://s29.postimg.org/5h0r4ftkn/ellipses_dial.png');\n  background-repeat: no-repeat;\n  background-position: center;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n  opacity: 0.15;\n}\n\n.ellipses__outer--thick {\n  width: 69.5%;\n  height: 69.5%;\n  border-color: #09383e transparent;\n  border-width: 2px;\n  transform: rotate(-45deg);\n  animation: ellipsesRotate 15s ease-in-out infinite;\n}\n\n.ellipses__orbit {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-width: 2px;\n  border-color: #09383e;\n  top: 1.3rem;\n  right: 6.75rem;\n}\n\n.ellipses__orbit::before {\n  content: '';\n  width: 0.7rem;\n  height: 0.7rem;\n  border-radius: 50%;\n  display: inline-block;\n  background-color: #09383e;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n@keyframes ellipsesRotate {\n  0% {\n    transform: rotate(-45deg);\n  }\n\n  100% {\n    transform: rotate(-405deg);\n  }\n}\n\n@keyframes ellipsesOrbit {\n  0% {\n    transform: rotate(0);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.order_detail_title {\n  color: '#00700 !important';\n  font-size: 'large !important';\n  background: \"black !important\";\n}\n.borderBottomGray {\n  border-bottom: \"1px solid gray\";\n}\n\n.hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 50px;\n  background: linear-gradient(to right, #ffffff, #f0f0f0);\n}\n\n.hero-content h1 {\n  color: #e00000;\n  font-size: 3rem;\n}\n\n.hero-content p {\n  color: #000;\n  font-size: 1.2rem;\n}\n\n.hero-image img {\n  width: 100%;\n  max-width: 600px;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.top-logistics,\n.global-countries,\n.connect-countries {\n  text-align: center;\n  padding: 50px;\n}\n\nbutton {\n  background-color: #e00000;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\nbutton:hover {\n  background-color: #ff4d4d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
